import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/codex-social-media";

export const Route = createFileRoute(path)({
	component: CodexSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using Codex",
			description:
				"Run social media from Codex. AgentReacher's MCP server lets OpenAI Codex draft, schedule, and ship posts next to the code it just wrote.",
		}),
});

function CodexSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="codex"
				title="Boost your Social Media using Codex"
				description="AgentReacher's MCP server plugs into Codex. The same agent that wrote the diff can now draft, schedule, and ship the launch tweet."
				primaryCta={{ label: "Connect Codex", to: "/signup" }}
				secondaryCta={{ label: "Setup docs", to: "/docs/mcp" }}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
